var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fuwuleixing-pdf"},[_c('div',{staticClass:"fuwuleixing-pdf-main"},[_c('Pdf',{attrs:{"url":_vm.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }